// Clemson University's undergraduate majors (#2840). Read on 2026-10-01 from
// the official 2026-2027 Undergraduate Catalog (catalog.clemson.edu,
// catoid=49), one page per college, each listing its programs by department
// with the degree (BS, BA, BFA, BLA, as the catalog writes them). The catalog
// lists each concentration or emphasis area as its own program line; here
// they are folded into one entry per major and degree, with the options in
// the note. Left out: minors, certificates, the undeclared and exploratory
// programs, General Engineering (a first-year program, not a degree),
// Prepharmacy (non-degree), the ROTC programs, and the Nursing lines for
// change of major, transfer, accelerated second degree and RN completion
// (the first-year Nursing BS is kept). Agricultural Education BS appears
// under both Agriculture and Education because the catalog lists it in both.
// The catalog's curly apostrophe in "Women's Leadership" is typed straight.
// The Performing Arts flag quotes Clemson's College Preparation page (the
// college file's `prep` source). The KB's majors list was the starting
// point; the catalog wins.
const majors = {
    "slug": "clemson-university",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree major in Clemson's official 2026-2027 Undergraduate Catalog, grouped by the college that offers it, with the degree it leads to. Concentrations and emphasis areas are listed with their major. Minors, certificates and graduate programs are left out.",
    "groups": [
        {
            "name": "College of Agriculture, Forestry and Life Sciences",
            "source": {
                "label": "Clemson 2026-2027 Undergraduate Catalog, College of Agriculture, Forestry and Life Sciences",
                "url": "https://catalog.clemson.edu/content.php?catoid=49&navoid=1994"
            },
            "majors": [
                {
                    "name": "Agribusiness",
                    "degree": "BS"
                },
                {
                    "name": "Agricultural Education",
                    "degree": "BS",
                    "note": "Choose one: Leadership Emphasis Area; Teaching Emphasis Area."
                },
                {
                    "name": "Agricultural Mechanization and Business",
                    "degree": "BS"
                },
                {
                    "name": "Animal and Veterinary Sciences",
                    "degree": "BS",
                    "note": "Choose one: Animal Agribusiness Concentration; Equine Business Concentration; Preveterinary and Science Concentration."
                },
                {
                    "name": "Food Science and Human Nutrition",
                    "degree": "BS",
                    "note": "Choose one: Food Science and Technology Concentration; Nutrition Concentration."
                },
                {
                    "name": "Packaging Science",
                    "degree": "BS"
                },
                {
                    "name": "Environmental and Natural Resources",
                    "degree": "BS",
                    "note": "Choose one: Conservation Biology Concentration; Natural Resource and Economic Policy Concentration; Natural Resources Management Concentration."
                },
                {
                    "name": "Forest Resource Management",
                    "degree": "BS",
                    "note": "Also offered with: Land Surveying Emphasis Area."
                },
                {
                    "name": "Wildlife and Fisheries Biology",
                    "degree": "BS"
                },
                {
                    "name": "Horticulture",
                    "degree": "BS"
                },
                {
                    "name": "Plant and Environmental Sciences",
                    "degree": "BS",
                    "note": "Choose one: Agricultural Biotechnology Concentration; Agronomy Concentration; Soil and Water Science Concentration."
                },
                {
                    "name": "Turfgrass",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Architecture, Art and Construction",
            "source": {
                "label": "Clemson 2026-2027 Undergraduate Catalog, College of Architecture, Art and Construction",
                "url": "https://catalog.clemson.edu/content.php?catoid=49&navoid=2011"
            },
            "majors": [
                {
                    "name": "Architecture",
                    "degree": "BA"
                },
                {
                    "name": "Landscape Architecture",
                    "degree": "BLA"
                },
                {
                    "name": "Art",
                    "degree": "BA"
                },
                {
                    "name": "Visual Arts",
                    "degree": "BFA"
                },
                {
                    "name": "Construction Science and Management",
                    "degree": "BS",
                    "note": "Also offered with: Residential Construction Concentration."
                }
            ]
        },
        {
            "name": "College of Arts and Humanities",
            "source": {
                "label": "Clemson 2026-2027 Undergraduate Catalog, College of Arts and Humanities",
                "url": "https://catalog.clemson.edu/content.php?catoid=49&navoid=2012"
            },
            "majors": [
                {
                    "name": "English",
                    "degree": "BA"
                },
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "Women's Leadership",
                    "degree": "BA"
                },
                {
                    "name": "World Cinema",
                    "degree": "BA"
                },
                {
                    "name": "Language and International Business",
                    "degree": "BA"
                },
                {
                    "name": "Modern Languages",
                    "degree": "BA",
                    "note": "Choose one: American Sign Language Emphasis Area; Chinese Emphasis Area; French Emphasis Area; German Emphasis Area; Italian Emphasis Area; Japanese Emphasis Area; Spanish Emphasis Area."
                },
                {
                    "name": "Language and International Health",
                    "degree": "BS"
                },
                {
                    "name": "Performing Arts",
                    "degree": "BA",
                    "note": "Choose one: Audio Technology Concentration; Music Concentration; Theatre Concentration.",
                    "flag": "An audition is required for the music and theatre concentrations.",
                    "flagSource": "prep"
                },
                {
                    "name": "Philosophy",
                    "degree": "BA",
                    "note": "Also offered with: Law, Liberty and Justice Emphasis Area; Medicine, Health, and Human Values Emphasis Area."
                },
                {
                    "name": "Religious Studies",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "College of Behavioral, Social and Health Sciences",
            "source": {
                "label": "Clemson 2026-2027 Undergraduate Catalog, College of Behavioral, Social and Health Sciences",
                "url": "https://catalog.clemson.edu/content.php?catoid=49&navoid=1995"
            },
            "majors": [
                {
                    "name": "Communication",
                    "degree": "BA"
                },
                {
                    "name": "Sports Communication",
                    "degree": "BA"
                },
                {
                    "name": "Nursing",
                    "degree": "BS"
                },
                {
                    "name": "Parks, Recreation and Tourism Management",
                    "degree": "BS",
                    "note": "Choose one: Parks, Recreation and Tourism Concentration; Recreational Therapy Concentration."
                },
                {
                    "name": "Political Science",
                    "degree": "BA"
                },
                {
                    "name": "Political Science",
                    "degree": "BS",
                    "note": "Choose one: American Politics Concentration; Global Politics Concentration; Political Economy Concentration; Public Policy and Administration Concentration."
                },
                {
                    "name": "Psychology",
                    "degree": "BA"
                },
                {
                    "name": "Psychology",
                    "degree": "BS"
                },
                {
                    "name": "Health Science",
                    "degree": "BS",
                    "note": "Choose one: Health Promotion and Behavior Concentration; Health Services Administration Concentration; Preprofessional Health Studies."
                },
                {
                    "name": "Anthropology",
                    "degree": "BA"
                },
                {
                    "name": "Criminal Justice",
                    "degree": "BA"
                },
                {
                    "name": "Sociology",
                    "degree": "BA"
                },
                {
                    "name": "Anthropology",
                    "degree": "BS"
                },
                {
                    "name": "Criminal Justice",
                    "degree": "BS"
                },
                {
                    "name": "Sociology",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Wilbur O. and Ann Powers College of Business",
            "source": {
                "label": "Clemson 2026-2027 Undergraduate Catalog, Wilbur O. and Ann Powers College of Business",
                "url": "https://catalog.clemson.edu/content.php?catoid=49&navoid=1996"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "BS"
                },
                {
                    "name": "Economics",
                    "degree": "BA"
                },
                {
                    "name": "Economics",
                    "degree": "BS"
                },
                {
                    "name": "Financial Management",
                    "degree": "BS"
                },
                {
                    "name": "Graphic Communications",
                    "degree": "BS"
                },
                {
                    "name": "Management",
                    "degree": "BS"
                },
                {
                    "name": "Marketing",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Education",
            "source": {
                "label": "Clemson 2026-2027 Undergraduate Catalog, College of Education",
                "url": "https://catalog.clemson.edu/content.php?catoid=49&navoid=1998"
            },
            "majors": [
                {
                    "name": "Special Education",
                    "degree": "BA"
                },
                {
                    "name": "Human Capital Education and Development",
                    "degree": "BS"
                },
                {
                    "name": "Early Childhood Education",
                    "degree": "BA"
                },
                {
                    "name": "Elementary Education",
                    "degree": "BA"
                },
                {
                    "name": "Modern Languages Education",
                    "degree": "BA",
                    "note": "Choose one: American Sign Language Teaching Area; French Teaching Area; Spanish Teaching Area."
                },
                {
                    "name": "Science Teaching",
                    "degree": "BA",
                    "note": "Choose one: Biological Sciences; Chemistry; Physics."
                },
                {
                    "name": "Secondary Education",
                    "degree": "BA",
                    "note": "Choose one: English; Mathematics; Social Studies (History)."
                },
                {
                    "name": "Agricultural Education",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics Teaching",
                    "degree": "BS"
                },
                {
                    "name": "Middle Level Education",
                    "degree": "BS",
                    "note": "Choose one: Language Arts and Social Studies Teaching Area; Mathematics and Science Teaching Area."
                },
                {
                    "name": "Science Teaching",
                    "degree": "BS",
                    "note": "Choose one: Biological Sciences."
                }
            ]
        },
        {
            "name": "College of Engineering, Computing and Applied Sciences",
            "source": {
                "label": "Clemson 2026-2027 Undergraduate Catalog, College of Engineering, Computing and Applied Sciences",
                "url": "https://catalog.clemson.edu/content.php?catoid=49&navoid=1997"
            },
            "majors": [
                {
                    "name": "Automotive Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Biomedical Engineering",
                    "degree": "BS",
                    "note": "Choose one: Bioelectrical Concentration; Biomaterials Concentration."
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Civil Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science",
                    "degree": "BA"
                },
                {
                    "name": "Computer Information Systems",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Computer Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Biosystems Engineering",
                    "degree": "BS",
                    "note": "Choose one: Bioprocess Engineering Emphasis Area; Ecological Engineering Emphasis Area."
                },
                {
                    "name": "Environmental Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Geology",
                    "degree": "BS",
                    "note": "Also offered with: Environmental Science Concentration; Hydrogeology Concentration."
                },
                {
                    "name": "Industrial Engineering",
                    "degree": "BS",
                    "note": "Also offered with: Computing Emphasis Area."
                },
                {
                    "name": "Materials Science and Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Science",
            "source": {
                "label": "Clemson 2026-2027 Undergraduate Catalog, College of Science",
                "url": "https://catalog.clemson.edu/content.php?catoid=49&navoid=1999"
            },
            "majors": [
                {
                    "name": "Biological Sciences",
                    "degree": "BA"
                },
                {
                    "name": "Biological Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Microbiology",
                    "degree": "BS",
                    "note": "Also offered with: Biomedicine Concentration."
                },
                {
                    "name": "Chemistry",
                    "degree": "BA"
                },
                {
                    "name": "Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Biochemistry",
                    "degree": "BS"
                },
                {
                    "name": "Genetics",
                    "degree": "BS"
                },
                {
                    "name": "Mathematical Sciences",
                    "degree": "BA"
                },
                {
                    "name": "Data Science",
                    "degree": "BS"
                },
                {
                    "name": "Mathematical Sciences",
                    "degree": "BS",
                    "note": "Also offered with: Biology Concentration."
                },
                {
                    "name": "Physics",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BS",
                    "note": "Also offered with: Interdisciplinary Emphasis Area."
                }
            ]
        }
    ]
};

export default majors;
